import { useQuery, UseQueryResult } from '@tanstack/react-query';
import { spacesQuery } from 'networking/mindfeed/queries/spaces';
import { Space } from 'models/Space';

export default function useSpaces(): UseQueryResult<Space[]> {
  return useQuery(spacesQuery());
}
